import { render, staticRenderFns } from "./MailVolume.vue?vue&type=template&id=7ff99320"
import script from "./MailVolume.vue?vue&type=script&lang=js"
export * from "./MailVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports